import { StyleSheet, Text, View } from 'react-native'
import React from 'react'

const DetailsScreen = () => {
  return (
    <View>
      <Text>DetailsScreeen</Text>
    </View>
  )
}

export default DetailsScreen

const styles = StyleSheet.create({})